import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Link } from '../../link/link.component.js';
import { Text } from '../../text/text.component.js';
import { StyledCardHeader } from './card-header.style.js';

const CardHeader = props => {
    const { className = '', children, icon, onClick, title, to } = props, rest = __rest(props, ["className", "children", "icon", "onClick", "title", "to"]);
    const getIcon = () => {
        if (!icon)
            return null;
        if (!to)
            return icon;
        return (jsx(Link, Object.assign({ to: to, type: "standalone", hideIcon: true }, { children: icon }), void 0));
    };
    return (jsxs(StyledCardHeader, Object.assign({ className: className, onClick: onClick }, rest, { children: [title ? (jsx(Text, Object.assign({ tag: "h2", textStyle: "heading700" }, { children: title }), void 0)) : (children), getIcon()] }), void 0));
};

export { CardHeader as default };
